import { connectCatchTile } from './connect';
import { Catch } from 'components/share/Catch';
import { withQuoteId } from 'components/contexts';

export const TileCatchError = withQuoteId(connectCatchTile(Catch));
